export default "__VITE_ASSET__Bm1Ip9uo__"